import type { FeatureConfig } from '@/core/registry'
import documentsRoutes from './routes'
import documentsLocales from './locales'
import { documentsHandlers } from './mocks'
import { DOCUMENT_PERMISSIONS } from './constants/permissions.constants'

const config: FeatureConfig = {
  routes: documentsRoutes,
  locales: { ns: 'documents', resources: documentsLocales },
  handlers: documentsHandlers,
  permissions: DOCUMENT_PERMISSIONS,
}

export default config
